import FormStyleEditorSecondaryButtonPanel from './FormStyleEditorSecondaryButtonPanel';

export default FormStyleEditorSecondaryButtonPanel;
